import { all } from 'redux-saga/effects';
import jobSaga from './job';

export const jobSagas = function* root() {
  yield all([jobSaga()]);
};
